export const googleMapDirectionInitialState = {
  isGetDirectionRouteLoading: false,
  directionRoute: null,
  directionRouteList: [],
  calculatedDistance: '_',
  isScriptLoadedSuccess: false,
}
